<template>
  <div>
    <Title :pages="[{ icon: 'clipboard-list', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <ModalFilterPicking
        v-model="dialog_filters"
        title="Filtros"
        :filters="filters"
        :almacenes="almacenes"
        :clients="clients"
        :canales-venta="canales_venta"
        @update:filters="updateFilters"
        @close="closeFilterModal"
        @apply="applyFilters"
      />

      <v-row>
        <v-col cols="12" md="8">
          <v-card style="min-height: 85vh">
            <div class="col-md-12 pt-2 pb-2" style="background:rgb(237,237,237); elevation-0">
              <div class="row">
                <div class="col-12">
                  <v-btn color="info" variant="text" @click="openFilterModal" small>+ Filtros</v-btn>

                  <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" closable @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
                </div>
              </div>
            </div>
            <v-card-title class="pb-2 operator-header-bg">
              <div class="operator-header">
                <span class="text-overline text-grey-darken-1 operator-title">GESTIÓN DE PICKING</span>
                <div class="operator-count-row">
                  <h2 class="operator-count">{{ list.length }}</h2>
                  <span class="operator-active-text">pendientes de preparación</span>
                </div>
              </div>
            </v-card-title>

            <v-card-text>
              <div class="d-flex justify-space-between align-center gap-2 mb-4 mt-4">
                <div class="d-flex align-center gap-2 ml-4 pl-2">
                  <v-checkbox v-if="list.length > 0" :model-value="allSelected" :indeterminate="someSelected" hide-details color="primary" @click="toggleSelectAll" density="compact">
                    <template v-slot:label>
                      <span class="text-body-2">
                        {{ allSelected ? "Deseleccionar todas" : "Seleccionar todas" }}
                        <span class="text-grey" v-if="selected.length > 0">({{ selected.length }} seleccionadas)</span>
                      </span>
                    </template>
                  </v-checkbox>
                </div>
                <div class="d-flex gap-2">
                  <v-btn color="primary" @click="openAssignUserModal" density="comfortable"> Asignar a Operario </v-btn>

                  <v-btn color="blue-grey" density="comfortable" prepend-icon="mdi-lightning-bolt" @click="openDistributeConfirm"> Distribuir todo </v-btn>
                </div>
              </div>

              <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

              <div v-if="!loading && list.length === 0" style="min-height: 60vh" class="d-flex flex-column align-center justify-center py-12 text-grey">
                <v-icon size="64" color="grey-lighten-1">mdi-package-variant</v-icon>
                <p class="mt-4">No hay órdenes pendientes de preparación</p>
              </div>

              <div v-else class="picking-list">
                <div
                  v-for="item in list"
                  :key="item.id"
                  class="picking-item"
                  :class="{
                    'picking-item-selected': isSelected(item),
                    'picking-item-dragging': is_dragging && isSelected(item),
                  }"
                  @click="toggleSelection(item)"
                  draggable="true"
                  @dragstart="onDragStart($event, item)"
                  @dragend="onDragEnd"
                >
                  <v-checkbox :model-value="isSelected(item)" hide-details color="primary" class="picking-checkbox" @click.stop="toggleSelection(item)"></v-checkbox>

                  <div class="picking-content">
                    <div class="picking-row">
                      <div class="picking-info">
                        <span class="picking-code">{{ item.code }}</span>
                      </div>

                      <div class="picking-meta">
                        <div class="picking-field mr-2">
                          <span class="field-label">Fecha</span> <br />
                          <span class="field-value">{{ item.creation_date }}</span>
                        </div>

                        <div v-if="item.client_id" class="picking-field mr-2">
                          <span class="field-label">Cliente</span><br />
                          <span class="field-value">{{ item.client_name }}</span>
                        </div>

                        <div class="picking-field mr-2">
                          <span class="field-label">Canal</span><br />
                          <span class="field-value">{{ item.canal_venta_name || "-" }}</span>
                        </div>

                        <div v-if="item.dock_id" class="picking-field mr-2">
                          <span class="field-label">Muelle</span><br />
                          <span class="field-value">{{ item.dock_name }}</span>
                        </div>

                        <div class="picking-field">
                          <span class="field-label">Tareas</span><br />
                          <span class="field-value">
                            <v-chip size="small" color="primary" variant="tonal"> {{ item.picking_tasks_count || 0 }} tareas </v-chip>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card style="min-height: 85vh">
            <v-card-title class="pb-2 operator-header-bg">
              <div class="operator-header">
                <span class="text-overline text-grey-darken-1 operator-title">OPERARIOS</span>
                <div class="operator-count-row">
                  <h2 class="operator-count">{{ totalOperatorsCount }}</h2>
                  <span class="operator-active-text">operarios ({{ activeOperatorsCount }} activos)</span>
                </div>
              </div>
            </v-card-title>

            <v-card-text class="pt-2">
              <v-text-field
                v-model="operator_order_search"
                append-inner-icon="mdi-magnify"
                label="Buscar envío en operarios"
                placeholder="Código de envío..."
                density="compact"
                variant="outlined"
                hide-details
                clearable
                class="mb-3"
                @update:model-value="onOperatorSearchChange"
              ></v-text-field>

              <v-progress-linear v-if="loading_operators" indeterminate color="primary" class="mb-3"></v-progress-linear>

              <div v-if="!loading_operators && active_operators.length === 0" style="min-height: 70vh" class="d-flex flex-column align-center justify-center py-12 text-grey">
                <v-icon size="48" color="grey-lighten-1">{{ operator_order_search ? "mdi-magnify-close" : "mdi-account-off" }}</v-icon>
                <p class="mt-2 text-caption">{{ operator_order_search ? `Ningún operario tiene el envío "${operator_order_search}"` : "No hay operarios disponibles" }}</p>
              </div>

              <div v-else class="operators-list">
                <div
                  v-for="operator in filteredOperators"
                  :key="operator.user_id"
                  class="operator-card"
                  :class="{
                    'operator-card-drag-over': drag_over_operator?.user_id === operator.user_id,
                  }"
                  @dragover.prevent="onDragOver($event, operator)"
                  @dragleave="onDragLeave"
                  @drop="onDrop($event, operator)"
                >
                  <div class="d-flex gap-3 w-100">
                  
                    <div class="operator-info flex-grow-1">
                      <div class="operator-name-row">
                        <div class="d-flex">
                        <div class="operator-avatar mr-2" :style="getIconStyle(operator.user_name)" :class="{ 'operator-avatar-inactive': !operator.is_active }">
                          <span class="operator-initials">{{ getInitials(operator.user_name) }}</span>
                        </div>
                        <div>

                          <p class="operator-name mb-0" :class="{ 'operator-name-inactive': !operator.is_active }">{{ operator.user_name }}</p>
                          <div class="d-flex align-center gap-1 mt-1">
                            <span :class="operator.is_active ? 'status-dot-active' : 'status-dot-inactive'"></span>
                            <span class="status-text" :class="{ 'status-text-inactive': !operator.is_active }">{{ operator.is_active ? "Activo" : "Inactivo" }}</span>
                          </div>
                        </div>
                        </div>
                        <div class="operator-assigned-count">
                          <div class="assigned-number" :class="{ 'assigned-number-inactive': !operator.is_active }">{{ operator.shipment_orders_count || 0 }}</div>
                          <div class="assigned-label" :class="{ 'assigned-label-inactive': !operator.is_active }">
                            {{ operator.shipment_orders_count === 1 ? "orden asignada" : "órdenes asignadas" }}
                          </div>
                        </div>
                      </div>
                      <div class="operator-orders mb-2">
                        <div class="d-flex align-center"></div>
                      </div>

                      <!-- Progreso de tareas -->
                      <div class="operator-progress mt-2 mb-2">
                        <div class="d-flex justify-space-between align-center mb-1">
                          <span class="text-caption font-weight-medium"> {{ operator.tasks_completed || 0 }} de {{ operator.total_tasks || 0 }} tareas </span>
                          <span class="text-caption font-weight-bold">{{ operator.progress_percentage || 0 }}%</span>
                        </div>
                        <v-progress-linear 
                          :model-value="operator.progress_percentage || 0" 
                          height="8" 
                          color="success" 
                          bg-color="black" 
                          rounded
                        ></v-progress-linear>
                      </div>

                      <!-- Botón Ver Detalles -->
                      <div class="mt-2 d-flex gap-2">
                        <!-- <v-btn size="small" color="primary" variant="tonal" prepend-icon="mdi-eye" @click.stop="openOperatorDetailModal(operator)" style="flex: 1"> Ver Tareas </v-btn> -->
                        <v-btn size="small" color="blue-grey" variant="tonal" prepend-icon="mdi-package-variant" @click.stop="openOperatorOrdersModal(operator)" style="flex: 1"> Ver Órdenes </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal Asignar Operario -->
    <v-dialog v-model="dialog_assign_user" max-width="500px" persistent>
      <v-card>
        <v-form>
          <v-card-title>
            <span class="headline">Asignar Operario</span>
          </v-card-title>
          <v-card-text class="pt-4">
            <p class="mb-4">
              Selecciona el operario al cual se asignarán las
              <strong>{{ selected.length }} órdenes de envío</strong>
              seleccionadas.
            </p>
            <v-combobox
              v-model="selected_user"
              density="comfortable"
              name="operario"
              item-title="name"
              item-value="id"
              :items="users"
              label="Operarios *"
              autocomplete="off"
              :disabled="loading_assign"
              clearable
              :rules="[(v) => !!v || 'El operario es requerido']"
            >
              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props">
                  <template v-slot:append>
                    <v-chip size="x-small" :color="item.raw.is_active ? 'success' : 'grey'" variant="flat">
                      {{ item.raw.is_active ? "Activo" : "Inactivo" }}
                    </v-chip>
                  </template>
                </v-list-item>
              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" variant="text" @click="closeAssignUserModal" :disabled="loading_assign"> Cancelar </v-btn>
            <v-btn color="success" variant="text" @click="confirmAssignUser" :loading="loading_assign" :disabled="!selected_user"> Asignar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Modal Detalle del Operador -->
    <!-- Modal Órdenes del Operador -->
    <ModalOperatorOrders
      v-if="selected_operator_orders"
      v-model="dialog_operator_orders"
      :operator="selected_operator_orders"
      :date-from="filters.date_from"
      :date-to="filters.date_to"
      @order-unassigned="handleOrderUnassigned"
    />

    <!-- Modal Confirmar Distribución -->
    <DialogYesNo
      :open="dialog_distribute_confirm"
      title="Distribución Automática"
      :message="`¿Desea distribuir ${list.length} órdenes entre ${activeOperatorsCount} operarios activos de forma automática?\n\nLas órdenes se asignarán equitativamente considerando la carga de trabajo actual de cada operario.`"
      :loading="loading_distribute"
      @accept="distributeAll"
      @cancel="closeDistributeConfirm"
    />
  </div>
</template>

<script>
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import { employeeService } from "@/libs/ws/employeeService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { canalesVentasService } from "@/libs/ws/canalesVentasService";
import { formatUtils } from "@/libs/utils/formatUtils";
import ConstantEmployeesType from "@/constants/employee_types.js";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import ModalFilterPicking from "./ModalFilterPicking.vue";
import ModalOperatorOrders from "./ModalOperatorOrders.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";

export default {
  components: {
    ModalFilterPicking,
    ModalOperatorOrders,
    DialogYesNo,
  },
  mixins: [GenericMixin, RolMixin, AliasMixin],
  data() {
    return {
      service: shipmentOrderService,
      formatUtils: formatUtils,
      page_title: "Gestión de Picking",
      clients: [],
      almacenes: [],
      canales_venta: [],
      users: [],
      active_operators: [],
      loading_operators: false,
      selected_operator: null,
      selected: [],
      is_dragging: false,
      drag_over_operator: null,
      selected_user: null,
      dialog_assign_user: false,
      loading_assign: false,
      dialog_filters: false,
      selected_filters: [],
      dialog_operator_detail: false,
      selected_operator_detail: null,
      dialog_operator_orders: false,
      selected_operator_orders: null,
      dialog_distribute_confirm: false,
      loading_distribute: false,
      operator_order_search: "",
      operator_search_debounce_timeout: null,
      operators_refresh_interval: null,
      filters: {
        date_from: (() => {
          const yesterday = new Date(
            new Date().toLocaleDateString("en-US", {
              timeZone: "America/Buenos_Aires",
            }),
          );
          yesterday.setDate(yesterday.getDate() - 1);
          return yesterday.toISOString().slice(0, 10);
        })(),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          }),
        )
          .toISOString()
          .slice(0, 10),
        client: null,
        almacen: null,
        canal_venta: null,
        wave_code: "",
        code: "",
        status_arr: [{ id: "STR" }], // Usar status_arr para arrays de estados
        date_type: "creation_date",
      },
    };
  },
  computed: {
    filteredOperators() {
      return this.active_operators;
    },
    activeOperatorsCount() {
      return this.active_operators.filter((op) => op.is_active).length;
    },
    totalOperatorsCount() {
      return this.active_operators.length;
    },
    allSelected() {
      return this.list.length > 0 && this.selected.length === this.list.length;
    },
    someSelected() {
      return this.selected.length > 0 && this.selected.length < this.list.length;
    },
  },
  mounted() {
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.loadCombobox();
    this.updateSelectedFilters();
    this.loadList(this.service, this.getFilterParams());
    this.startOperatorsAutoRefresh();
  },
  beforeUnmount() {
    if (this.operator_search_debounce_timeout) {
      clearTimeout(this.operator_search_debounce_timeout);
      this.operator_search_debounce_timeout = null;
    }
    this.stopOperatorsAutoRefresh();
  },
  methods: {
    onOperatorSearchChange() {
      if (this.operator_search_debounce_timeout) {
        clearTimeout(this.operator_search_debounce_timeout);
      }

      this.operator_search_debounce_timeout = setTimeout(() => {
        this.loadActiveOperators();
      }, 350);
    },
    getIconStyle(name) {
      const colors = ["#1976D2", "#388E3C", "#D32F2F", "#7B1FA2", "#F57C00", "#0097A7", "#C2185B", "#5D4037", "#455A64", "#E64A19"];
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const index = Math.abs(hash) % colors.length;
      return { backgroundColor: colors[index] };
    },
    getInitials(name) {
      if (!name) return "??";
      const parts = name.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    loadCombobox() {
      this.loadAlmacenes();
      this.loadClientes();
      this.loadCanalesVentas();
      this.loadActiveOperators();
    },
    getFilterParams() {
      const params = { ...this.filters };
      // Asegurar que siempre se filtre por estado STR
      params.status_arr = [{ id: "STR" }];
      // Filtrar solo pedidos sin usuario asignado
      params.user_assignated_null = true;
      // Incluir conteo de picking tasks
      params.include_picking_tasks = true;
      return params;
    },
    filter() {
      this.selected = [];
      this.loadList(this.service, this.getFilterParams());
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("Error cargando almacenes", e);
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("Error cargando clientes", e);
        });
    },
    loadCanalesVentas() {
      canalesVentasService
        .filter({})
        .then((response) => {
          this.canales_venta = response.result;
        })
        .catch((e) => {
          console.log("Error cargando canales de venta", e);
        });
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },
    updateFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
      this.updateSelectedFilters();
    },
    applyFilters() {
      this.updateSelectedFilters();
      this.filter();
      this.loadActiveOperators(); // Recargar operadores con el nuevo rango de fechas
      this.closeFilterModal();
    },
    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.key) {
        if (filtered.key === "date_from") {
          const yesterday = new Date(
            new Date().toLocaleDateString("en-US", {
              timeZone: "America/Buenos_Aires",
            }),
          );
          yesterday.setDate(yesterday.getDate() - 1);
          this.filters.date_from = yesterday.toISOString().slice(0, 10);
        } else if (filtered.key === "date_to") {
          this.filters.date_to = new Date(
            new Date().toLocaleDateString("en-US", {
              timeZone: "America/Buenos_Aires",
            }),
          )
            .toISOString()
            .slice(0, 10);
        } else if (filtered.key === "wave_code" || filtered.key === "code") {
          this.filters[filtered.key] = "";
        } else {
          this.filters[filtered.key] = null;
        }
      }

      this.updateSelectedFilters();
      this.filter();
      this.loadActiveOperators(); // Recargar operadores al cambiar fechas
    },
    updateSelectedFilters() {
      this.selected_filters = [];

      if (this.filters.date_from) {
        this.selected_filters.push({
          key: "date_from",
          label: "Fecha Desde",
          value: this.filters.date_from,
        });
      }
      if (this.filters.date_to) {
        this.selected_filters.push({
          key: "date_to",
          label: "Fecha Hasta",
          value: this.filters.date_to,
        });
      }
      if (this.filters.almacen) {
        this.selected_filters.push({
          key: "almacen",
          label: "Almacén",
          value: this.filters.almacen.name,
        });
      }
      if (this.filters.client) {
        this.selected_filters.push({
          key: "client",
          label: "Cliente",
          value: this.filters.client.name,
        });
      }
      if (this.filters.canal_venta) {
        this.selected_filters.push({
          key: "canal_venta",
          label: "Canal de Venta",
          value: this.filters.canal_venta.name,
        });
      }
      if (this.filters.wave_code) {
        this.selected_filters.push({
          key: "wave_code",
          label: "Número de Ola",
          value: this.filters.wave_code,
        });
      }
      if (this.filters.code) {
        this.selected_filters.push({
          key: "code",
          label: "Número de Envío",
          value: this.filters.code,
        });
      }
    },
    openAssignUserModal() {
      if (this.selected.length === 0) {
        this.toast.warning("Debe seleccionar al menos una orden de envío");
        return;
      }
      this.dialog_assign_user = true;
    },
    closeAssignUserModal() {
      this.dialog_assign_user = false;
      this.selected_user = null;
    },
    openOperatorDetailModal(operator) {
      this.selected_operator_detail = operator;
      this.dialog_operator_detail = true;
    },
    openOperatorOrdersModal(operator) {
      this.selected_operator_orders = operator;
      this.dialog_operator_orders = true;
    },
    handleOrderUnassigned() {
      // Recargar lista de órdenes pendientes y operarios activos
      this.filter();
      this.loadActiveOperators();
    },
    confirmAssignUser() {
      if (!this.selected_user) {
        this.toast.warning("Debe seleccionar un usuario");
        return;
      }

      this.loading_assign = true;

      const params = {
        shipment_order_ids: this.selected.map((item) => item.id),
        user_id: this.selected_user.id,
      };

      this.service
        .assignPickingUser(params)
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg || "Órdenes asignadas correctamente");
            this.closeAssignUserModal();
            this.selected = [];
            this.filter();
            this.loadActiveOperators();
          } else {
            this.toast.error(response.msg || "Error al asignar órdenes");
          }
        })
        .catch((e) => {
          this.toast.error("Error al asignar órdenes al usuario");
          console.log(e);
        })
        .finally(() => {
          this.loading_assign = false;
        });
    },
    isSelected(item) {
      return this.selected.some((s) => s.id === item.id);
    },
    toggleSelection(item) {
      const index = this.selected.findIndex((s) => s.id === item.id);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.list];
      }
    },
    loadActiveOperators(silent = false) {
      if (!silent) {
        this.loading_operators = true;
      }
      const params = {
        enable: true,
        employee_type: ConstantEmployeesType.TYPE_OPERATOR,
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        load_all_operators: true, // Cargar todos los operarios, no solo activos
      };

      // Agregar filtro de almacén si existe
      if (this.filters.almacen && this.filters.almacen.id) {
        params.almacen_id = this.filters.almacen.id;
      }

      if (this.operator_order_search && this.operator_order_search.trim() !== "") {
        params.shipment_order_code = this.operator_order_search.trim();
      }

      employeeService
        .getActiveOperatorsWithTasks(params)
        .then((response) => {
          this.active_operators = response.result.operators;
          // También actualizar la lista de usuarios para el combobox
          this.users = response.result.operators.map((operator) => ({
            id: operator.user_id,
            name: operator.user_name,
            is_active: operator.is_active,
          }));
        })
        .catch((e) => {
          console.log("Error cargando operarios", e);
          if (!silent) {
            this.toast.error("Error al cargar operarios");
          }
        })
        .finally(() => {
          this.loading_operators = false;
        });
    },
    selectOperator(operator) {
      if (this.selected_operator?.user_id === operator.user_id) {
        this.selected_operator = null;
      } else {
        this.selected_operator = operator;
      }
    },

    assignToSelectedOperator() {
      if (!this.selected_operator) {
        this.toast.warning("Debe seleccionar un operario");
        return;
      }
      if (this.selected.length === 0) {
        this.toast.warning("Debe seleccionar al menos una orden de envío");
        return;
      }

      this.loading_assign = true;

      const params = {
        shipment_order_ids: this.selected.map((item) => item.id),
        user_id: this.selected_operator.user_id,
      };

      this.service
        .assignPickingUser(params)
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg || "Órdenes asignadas correctamente");
            this.selected_operator = null;
            this.selected = [];
            this.filter();
            this.loadActiveOperators();
          } else {
            this.toast.error(response.msg || "Error al asignar órdenes");
          }
        })
        .catch((e) => {
          this.toast.error("Error al asignar órdenes al operario");
          console.log(e);
        })
        .finally(() => {
          this.loading_assign = false;
        });
    },
    onDragStart(event, item) {
      this.is_dragging = true;
      // Si el item arrastrado no está seleccionado, seleccionarlo automáticamente
      if (!this.isSelected(item)) {
        this.selected = [item];
      }
      // Guardar los IDs de los items seleccionados en el evento
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", JSON.stringify(this.selected.map((s) => s.id)));
    },
    onDragEnd() {
      this.is_dragging = false;
      this.drag_over_operator = null;
    },
    onDragOver(event, operator) {
      event.preventDefault();
      event.dataTransfer.dropEffect = "move";
      this.drag_over_operator = operator;
    },
    onDragLeave() {
      this.drag_over_operator = null;
    },
    onDrop(event, operator) {
      event.preventDefault();
      this.drag_over_operator = null;
      this.is_dragging = false;

      if (this.selected.length === 0) {
        this.toast.warning("No hay órdenes seleccionadas para asignar");
        return;
      }

      this.loading_assign = true;

      const params = {
        shipment_order_ids: this.selected.map((item) => item.id),
        user_id: operator.user_id,
      };

      this.service
        .assignPickingUser(params)
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg || `Órdenes asignadas a ${operator.user_name}`);
            this.selected_operator = null;
            this.selected = [];
            this.filter();
            this.loadActiveOperators();
          } else {
            this.toast.error(response.msg || "Error al asignar órdenes");
          }
        })
        .catch((e) => {
          this.toast.error("Error al asignar órdenes al operario");
          console.log(e);
        })
        .finally(() => {
          this.loading_assign = false;
        });
    },
    openDistributeConfirm() {
      if (this.list.length === 0) {
        this.toast.warning("No hay órdenes para distribuir");
        return;
      }

      if (this.activeOperatorsCount === 0) {
        this.toast.warning("No hay operadores activos disponibles");
        return;
      }

      this.dialog_distribute_confirm = true;
    },
    closeDistributeConfirm() {
      this.dialog_distribute_confirm = false;
    },
    async distributeAll() {
      this.loading_distribute = true;

      try {
        // Filtrar solo operarios activos para la distribución
        const activeOperators = this.active_operators.filter((op) => op.is_active);

        const params = {
          shipment_order_ids: this.list.map((item) => item.id),
          operator_user_ids: activeOperators.map((op) => op.user_id),
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
        };

        const response = await this.service.distributePickingAutomatically(params);

        if (response.status) {
          this.toast.success(response.msg || "Órdenes distribuidas exitosamente");

          // Mostrar detalles de la distribución
          if (response.result && response.result.assignments) {
            let details = "\n\nDetalle de asignaciones:\n";
            response.result.assignments.forEach((assignment) => {
              details += `• ${assignment.operator}: ${assignment.orders_count} órdenes\n`;
            });
            console.log(details);
          }

          this.selected = [];
          this.filter();
          this.loadActiveOperators();
          this.closeDistributeConfirm();
        } else {
          this.toast.error(response.msg || "Error al distribuir órdenes");
        }
      } catch (error) {
        console.error("Error en distribución:", error);
        this.toast.error("Error al distribuir órdenes");
      } finally {
        this.loading_distribute = false;
      }
    },
    startOperatorsAutoRefresh() {
      this.stopOperatorsAutoRefresh();
      this.operators_refresh_interval = setInterval(() => {
        this.loadActiveOperators(true);
      }, 2 * 60 * 1000); // cada 2 minutos
    },
    stopOperatorsAutoRefresh() {
      if (this.operators_refresh_interval) {
        clearInterval(this.operators_refresh_interval);
        this.operators_refresh_interval = null;
      }
    }
  },
};
</script>